import {POST} from "@/utils/request/request";
import {commCode} from "@/consts";
// import {POST} from "@/services/Api";

export function ListAnimal(data) {
  return POST(commCode.Animal.ListAnimal, data)
}

export function CreateAnimal(data) {
  return POST(commCode.Animal.CreateAnimal, data)
}
export function DeleteAnimal(data) {
  return POST(commCode.Animal.DeleteAnimal, data)
}

export function UpdateAnimal(data) {
  return POST(commCode.Animal.UpdateAnimal, data)
}


export function SingleAnimal(data) {
  return POST(commCode.Animal.SingleAnimal, data)
}

export function TopUpAnimal(data) {
  return POST(commCode.Animal.TopUpAnimal, data)
}
export function ChgStatusAnimal(data) {
  return POST(commCode.Animal.ChgStatusAnimal, data)
}
